
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`La petite histoire`}</em></p>
    <p>{`La vaccination, c’est aussi une affaire de géopolitique et ce n’est pas un
hasard si ce vaccin porte le nom du premier satellite spatial russe lancé
en 1957. En août 2020, `}<a parentName="p" {...{
        "href": "630354149703"
      }}>{`Vladimir Poutine a annoncé`}</a>{` qu’un
organisme russe de réglementation avait approuvé ce vaccin, alors que les essais
de phase III n’avaient pas commencé. Cette annonce a été critiquée et le
président a dû faire marche arrière, en précisant qu’il s’agissait d’un
enregistrement conditionnel qui dépendrait des résultats des essais.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;